import { StatusPill } from './ui/StatusPill.jsx';
import { useSession, useSync } from './contexts.jsx';
import { Link } from 'wouter-preact';

export function AppShell({ children }) {
  const session = useSession();
  const sync = useSync();
  const label = import.meta.env.VITE_EVENT_LABEL || 'SPS';
  return (
    <div class="appshell">
      <header>
        <div class="title">
          {label}
          {session?.staff_name ? ` · ${session.staff_name}` : ''}
        </div>
        <StatusPill status={sync.status} pending={sync.pending} conflicts={sync.conflicts} />
        {session?.role === 'admin' && (
          <Link href="/admin" class="btn">
            Admin
          </Link>
        )}
        <button
          class="btn"
          onClick={() => {
            if (
              sync.pending > 0 &&
              !confirm(`${sync.pending} handover(s) not yet synced. Sign out anyway?`)
            )
              return;
            session.clearSession();
          }}
        >
          Sign out
        </button>
      </header>
      <main>{children}</main>
    </div>
  );
}
